import { render, staticRenderFns } from "./changePic.vue?vue&type=template&id=2d505194&scoped=true&"
import script from "./changePic.vue?vue&type=script&lang=js&"
export * from "./changePic.vue?vue&type=script&lang=js&"
import style0 from "./changePic.vue?vue&type=style&index=0&id=2d505194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d505194",
  null
  
)

export default component.exports